export const assetTypes = {
    DRIVE: 'Drive',
    MOTOR: 'Motor',
    SMART_SENSOR: 'SmartSensor',
    GENERIC_MACHINE: 'GenericMachine'
};

export const UNKNOWN_GATEWAY_NAME = 'UnKnown';

export const GATEWAY_TYPE = {
    DCP: 'DCP',
    NETA21: 'NETA21',
    EGW02: 'EGW02',
    CASSIA: 'Cassia',
    ARUBA: 'Aruba',
    MACH_SENSE_R: 'MachSenseR'
};

export const assetMenuItems = {
    DELETE_ASSET: 'gatewayAsset/DELETE_ASSET',
    DISCONNECT_ASSET: 'gatewayAsset/DISCONNECT_ASSET',
    PARAMETER_BACKUP: 'gatewayAsset/PARAMETER_BACKUP',
    SWITCH_TO_ANOTHER_GATEWAY: 'gatewayAsset/SWITCH_TO_ANOTHER_GATEWAY',
    MOVE_GATEWAY_ASSET: 'gatewayAsset/MOVE_GATEWAY_ASSET',
    EXPORT_MESSAGE_ARCHIVE: 'gatewayAsset/EXPORT_MESSAGE_ARCHIVE'
};
export const gatewayRouteURL = 'tools';
